import { http } from "api/http";

const getShifts = ({ queryKey }: any) => {
  return http.get(`/shifts/${queryKey[1]}`);
};

const createShift = (data: any) => {
  return http.post("/shifts", data);
};

const updateShift = ({ id, data }: { id: number; data: any }) => {
  return http.put(`/shifts/${id}`, data);
};

const deleteShift = (id: any) => {
  return http.delete(`/shifts/${id?.id}`);
};

const markShiftAsDefault = (id: number) => {
  return http.put(`/shifts/${id}/default`);
};

const assignShiftUsers = ({ id, userIds }: { id: number; userIds: number[] }) => {
  return http.put(`/shifts/${id}/users`, { userIds });
};

const getTodayShift = () => {
  return http.get("/shifts/today");
};

const getUserDateShift = ({ queryKey }: any) => {
  const [, { userId, date }] = queryKey;
  return http.get("/shifts/user-date", { params: { userId, date } });
};

export { getShifts, createShift, updateShift, deleteShift, markShiftAsDefault, assignShiftUsers, getTodayShift, getUserDateShift };
